import React from "react";
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './constants';
import 'primeicons/primeicons.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.css';
import "@fontsource/urbanist";
import { PrimeReactProvider } from "primereact/api";

const nonce = document
  .querySelector("meta[name='csp-nonce']")
  ?.getAttribute("content") || "";


  const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

 const value = {
        nonce: nonce
    };

root.render(
   <React.StrictMode>
    <PrimeReactProvider value={value}>
     <App nonce={nonce} />
     </PrimeReactProvider>
   </React.StrictMode>
);
